export default {
  name: 'vx-500-page',
  components: {},
  props: {
    i18n: {
      type: Object,
    },
  },
  data() {
    return {

    };
  },
  computed: {

  },
  async mounted() {

  },
  methods: {

  },
};



// WEBPACK FOOTER //
// ./src/components/nfr/vx-500-page/vx-500-page.js